import React from "react";
import { Outlet } from "react-router-dom";

const PainelExecutivo: React.FC = () => {
  return <Outlet />;
};

export default PainelExecutivo;
